




import  { ReportKey } from "../../redux/comparativeDashSlice";

export interface ComparativeCardConfig {
reportKey:       ReportKey;
  title:           string;
  subtitle:        string;
  backgroundColor: string;
  // The backend endpoint for this report type
  endpoint:        string;
  // Any extra query params beyond CompCode / FY / UserID
  extraParams?:    Record<string, string | number>;
}

// ── Card definitions ──────────────────────────────────────────
// Only 2 are active for Phase 1.  Uncomment the rest as backend
// endpoints become available.

export const COMPARATIVE_CARD_CONFIG: ComparativeCardConfig[] = [

  // ── Phase 1: 2 active cards ──────────────────────────────────
{
    reportKey: "sales",
    title: "Sales Comparison",
    subtitle: "Current vs Last Year Sales",
    backgroundColor: "#234549",
    endpoint: "Report/GetDashboardComparitiveData",
    extraParams: { VchType: "9" }, // Sale API param
  },
  {
    reportKey: "purchase",
    title: "Purchase Comparison",
    subtitle: "Current vs Last Year Purchase",
    backgroundColor: "#244834",
    endpoint: "Report/GetDashboardComparitiveData",
    extraParams: { VchType: "2" }, // Purchase API param
  }
//   {
//     reportKey:       "accountWise",
//     title:           "Sales Account Wise",
//     subtitle:        "Customer-level sales comparison",
//     backgroundColor: "#234549",
//     endpoint:        "Report/GetCompanyComparativeSalesData",
//     // No extra params needed for this one
//   },

//   {
//     reportKey:       "salesAccountWise",
//     title:           "Purchase Account Wise",
//     subtitle:        "Vendor-level purchase comparison",
//     backgroundColor: "#244834",
//     endpoint:        "Report/GetCompanyComparativePurchaseData",
//   },

  // ── Phase 2: 4 more (uncomment when APIs are ready) ──────────

  // {
  //   reportKey:       "accountGroupWise",
  //   title:           "Account Group Wise",
  //   subtitle:        "Group-level comparison",
  //   backgroundColor: "#60452a",
  //   endpoint:        "Report/GetCompanyComparativeAccountGroupData",
  // },

  // {
  //   reportKey:       "accountCategoryWise",
  //   title:           "Account Category Wise",
  //   subtitle:        "Category-level comparison",
  //   backgroundColor: "#4a3a5b",
  //   endpoint:        "Report/GetCompanyComparativeAccountCategoryData",
  // },

  // {
  //   reportKey:       "itemGroupWise",
  //   title:           "Item Group Wise",
  //   subtitle:        "Item group comparison",
  //   backgroundColor: "#1B2850",
  //   endpoint:        "Report/GetCompanyComparativeItemGroupData",
  // },

  // {
  //   reportKey:       "itemCategoryWise",
  //   title:           "Item Category Wise",
  //   subtitle:        "Item category comparison",
  //   backgroundColor: "#8f252c",
  //   endpoint:        "Report/GetCompanyComparativeItemCategoryData",
  // },
];

